module.exports = __webpack_public_path__ + "media/images/countryrect/lv-520372e1e1b4fc7a1f4c24b1fe0b2959.svg";